// 给所有 image__reveal-container 下面的图片添加超链接
document.addEventListener('DOMContentLoaded', function() {
  // 查找所有 image__reveal-container 元素
  const revealContainers = document.querySelectorAll('.image__reveal-container');
  
  revealContainers.forEach(function(container) {
    // 在每个容器中查找图片
    const images = container.querySelectorAll('img');
    
    images.forEach(function(img) {
      // 检查图片是否已经被链接包装
      if (img.parentElement.tagName !== 'A') {
        // 创建链接元素
        const link = document.createElement('a');
        link.href = 'https://thehonestlabel.com/products/graphite-antimicrobial-sheet-sets'; // 替换为您想要的链接
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        
        // 将图片包装在链接中
        img.parentNode.insertBefore(link, img);
        link.appendChild(img);
      }
    });
  });
});